

/// <reference path="PresetItem.ts" />

// Generated class PresetBlank_ManagedObject

class PresetBlank_ManagedObject extends PresetItem
{
}
